export default "__VITE_ASSET__DwpogBYt__"